/* eslint-disable no-unused-vars */
import BaseMiddleware from './BaseMiddleware'

export default class DefaultingBlockMiddleware extends BaseMiddleware {
    /**
     * Avalia se deve executar este middleware ou não
     *
     * @param {Route} to de qual rota está vindo
     * @param {Route} _from para qual rota está indo
     *
     * @return {boolean} deve executar este middleware?
     */
    shouldRun(to, _from) {
        // Executa em todas as rotas protegidas, exceto nas de faturas
        return to.meta.requiresAuth && !to.meta.billable
    }

    /**
     * Executa ações sobre esta rota
     *
     * @param {Route} _to de qual rota está vindo
     * @param {Route} _from para qual rota está indo
     *
     * @return {boolean} deve retornar false quando este middleware modifica a rota com next
     */
    handle(_to, _from, next) {
        // Precisa importar store aqui pois não tem acesso a this.$store
        const store = require('@/store').default

        // Verifica se o reseller atual está bloqueado por inadimplência
        const isBlocked = store.getters['reseller/isBlockedForDefaulting']

        if (isBlocked) {
            // Redireciona para a página de faturas
            next({ name: 'bills' })
            return false
        }

        return true
    }
}
